import React, { useState } from 'react';
import { login, getApiBaseUrl, setApiBaseUrl } from '../utils/auth';

const Login: React.FC = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [apiBaseUrl, setApiBaseUrlState] = useState(getApiBaseUrl());

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      if (!apiBaseUrl.trim()) {
        setError('Please enter API endpoint (e.g., http://localhost:4020)');
        return;
      }
      setApiBaseUrl(apiBaseUrl);
      await login(userName, password);
      window.location.href = '/overview';
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center' }}>
      <form onSubmit={handleSubmit} style={{ width: 360, padding: 24, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff' }}>
        <h2 style={{ marginTop: 0, marginBottom: 16 }}>API Endpoint</h2>
        <input
          type="text"
          value={apiBaseUrl}
          onChange={(e) => setApiBaseUrlState(e.target.value)}
          style={{ width: '100%', padding: '8px 10px', marginBottom: 16, border: '1px solid #d1d5db', borderRadius: 6 }}
          placeholder="http://localhost:4020"
        />
        <h2 style={{ marginTop: 0, marginBottom: 16 }}>Sign in</h2>
        <label style={{ display: 'block', fontSize: 12, color: '#6b7280' }}>Username</label>
        <input
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          style={{ width: '100%', padding: '8px 10px', marginBottom: 12, border: '1px solid #d1d5db', borderRadius: 6 }}
          placeholder="admin"
          autoFocus
        />
        <label style={{ display: 'block', fontSize: 12, color: '#6b7280' }}>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: '100%', padding: '8px 10px', marginBottom: 16, border: '1px solid #d1d5db', borderRadius: 6 }}
          placeholder="••••••••"
        />
        {error && <div style={{ color: '#ef4444', fontSize: 12, marginBottom: 12 }}>{error}</div>}
        <button
          type="submit"
          disabled={loading}
          style={{ width: '100%', padding: '10px 12px', background: '#111827', color: '#fff', border: 0, borderRadius: 6, cursor: 'pointer' }}
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};

export default Login;


